import { render, staticRenderFns } from "./MemberAvatar.vue?vue&type=template&id=154330c1&scoped=true"
import script from "./MemberAvatar.vue?vue&type=script&lang=js"
export * from "./MemberAvatar.vue?vue&type=script&lang=js"
import style0 from "./MemberAvatar.vue?vue&type=style&index=0&id=154330c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154330c1",
  null
  
)

export default component.exports